import { AppVersionDialog } from '@/components/layout/app-version/app-version-dialog'
import { CartMini } from '@/components/layout/header/cart-mini'
import { Container } from '@/components/ui/container'
import { useVersionDialog } from '@/hooks/use-version-dialog'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { SearchBar } from '../search-bar'
import { MobileNav } from './mobile-nav/mobile-nav'
import { MainNav } from './navigation-menu'

const UserMenu = dynamic(
  () => import('./user-menu').then((mod) => mod.UserMenu),
  {
    ssr: false,
  }
)

export const Navbar = ({ isMobile }: { isMobile?: boolean }) => {
  const { isOpen, handleRapidClick, handleOpenChange } = useVersionDialog()
  const router = useRouter()

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault()
    const isRapidClick = handleRapidClick()
    if (!isRapidClick) {
      router.push('/')
    }
  }

  return (
    <div className='h-13 border-b border-b-neutral-300 bg-background shadow-sm lg:h-17'>
      <Container size='full' className='h-full'>
        <div className='relative flex h-full items-center justify-between'>
          {isMobile && (
            <div className='flex flex-1 items-center text-neutral-800'>
              <MobileNav />

              <SearchBar isMobile />
            </div>
          )}

          <figure className='flex flex-1 justify-center lg:justify-start'>
            <Link
              href={'/'}
              className='flex h-10 w-10 items-center justify-center'
              onClick={handleLogoClick}
            >
              {isMobile ? (
                <Image
                  src={'/images/logo-mobile.svg'}
                  alt='Logo Coolmate Mobile'
                  width={36}
                  height={33}
                  priority={isMobile}
                />
              ) : (
                <Image
                  src={'/images/logo.png'}
                  alt='Logo Coolmate'
                  width={90}
                  height={50}
                  priority={!isMobile}
                  className='min-w-[90px]'
                />
              )}
            </Link>
          </figure>
          {!isMobile && <MainNav />}

          <div className='flex flex-1 items-center justify-end text-neutral-800'>
            {!isMobile && (
              <div className='lg:w-52 xl:w-[280px]'>
                <SearchBar />
              </div>
            )}

            <UserMenu />
            <CartMini />
          </div>
        </div>
      </Container>

      <AppVersionDialog open={isOpen} onOpenChange={handleOpenChange} />
    </div>
  )
}
